export default __webpack_public_path__ + "static/media/btn-left-off@3x.e652ffa3.png";